import { BiArrowBack } from 'react-icons/bi'; 
import { useNavigate } from 'react-router-dom';

export const BackButton = () => {
  const navigate = useNavigate();

  return (
    <button 
      onClick={() => navigate(-1)} 
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        background: 'transparent',
        border: 'none',
        fontSize: '16px',
        cursor: 'pointer',
        color: '#333'
      }}
    >
      <BiArrowBack size={20} />
      {/* Back */}
    </button>
  );
};
